// Permissions helper utilities

export const USER_ROLES = {
  ADMIN: 'Admin',
  OFFICER: 'Officer',
  VARSITY: 'Varsity',
  CLUB_NOVICE: 'Club Novice',
  CLASS_NOVICE: 'Class Novice'
};

export const isAdmin = (user) => {
  const adminEmails = ['kaseywilleby@gmail.com', 'mr.willeby@gmail.com'];
  return (
    (user?.email && adminEmails.map(e => e.toLowerCase()).includes(user.email.toLowerCase())) ||
    user?.role === USER_ROLES.ADMIN
  );
};

export const isOfficerOrVarsity = (user) => {
  return user?.role === USER_ROLES.OFFICER || user?.role === USER_ROLES.VARSITY;
};

export const canAccessLessonPlanner = (user) => {
  return isAdmin(user);
};

export const canAccessTaskManager = (user) => {
  return isAdmin(user);
};

export const canAccessDailySummary = (user) => {
  return isAdmin(user);
};

export const canAccessDebateCurriculum = (user) => {
  return isAdmin(user);
};

export const canAccessTeamDashboard = (user) => {
  // Only Officers, Varsity, and Admins can access Team Dashboard
  // Club Novice and Class Novice cannot access it
  return isAdmin(user) || isOfficerOrVarsity(user);
};

export const canSeeCurriculum = (user) => {
  // Only Class Novice users (and not logged in users) can see curriculum
  // Not logged in = user is null/undefined
  if (!user) return true; // Not logged in users can see it
  return user?.role === USER_ROLES.CLASS_NOVICE;
};

export const canViewPointTracker = (user) => {
  // Everyone can view
  return true;
};

export const canEditPointTracker = (user) => {
  // Only if they have the permission enabled
  return user?.permissions?.pointTracking === true || isAdmin(user);
};

export const canAccessSessionHostScheduler = (user) => {
  return user?.permissions?.sessionHost === true || isAdmin(user);
};

export const canEditOtherHostsAvailability = (user) => {
  // Only admins can edit other hosts' availability
  return isAdmin(user);
};

export const canDeleteAnyTask = (user) => {
  return isAdmin(user);
};

export const canDeleteOwnTask = (user, taskCreatorId) => {
  return user?.uid === taskCreatorId || isAdmin(user);
};

export const canDeleteCompletedTask = (user) => {
  return isAdmin(user);
};

export const canCancelOwnAppointment = (user) => {
  return true; // Everyone can cancel their own appointments
};
